export class RouteData {
    type: RouteType;
    data: any;

    constructor(type: RouteType, data: any) {
        this.type = type;
        this.data = data && data.toLowerCase();
    }

    public static logIn(): RouteData {
        return new RouteData(RouteType.LogIn, undefined);
    }

    public static page(pageName: string): RouteData {
        return new RouteData(RouteType.Page, pageName);
    }

    public static module(moduleName: string): RouteData {
        return new RouteData(RouteType.Module, moduleName);
    }
}

export enum RouteType {
    Module,
    Page,
    LogIn
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/route-data.ts